import React from 'react';
import PropTypes from 'prop-types';

const AssignedFile = ({ color = '#224251', fillColor = '#fff', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={30} height={31} viewBox="0 0 30 31" fill="none" {...props}>
    <g>
      <path
        fill={fillColor}
        d="M16.25 4.758h-10V26.65L10 25.434l3.75 1.216 3.75-1.216 3.75 1.216V9.623c0-2.294 0-3.44-.733-4.152-.732-.713-1.91-.713-4.267-.713Z"
      />
      <path
        stroke={color}
        d="M6.25 4.758h10c2.358 0 3.535 0 4.267.713.733.712.733 1.858.733 4.152V26.65l-3.75-1.216-3.75 1.216L10 25.434 6.25 26.65V4.15"
      />
      <path
        stroke={color}
        strokeLinecap="round"
        strokeWidth={0.7}
        d="M18.125 11.65H12.5m3.75 1.182H12.5M18.125 19.15H12.5m3.75 1.182H12.5"
      />
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.7}
        d="m8.75 22.275 1.875-2.355H8.75L10 17.9"
      />
      <path
        stroke={color}
        strokeLinejoin="round"
        strokeWidth={0.7}
        d="M11.25 12.9a1.25 1.25 0 1 1-2.5 0c0-.69 1.25-2.5 1.25-2.5s1.25 1.81 1.25 2.5Z"
        clipRule="evenodd"
      />
      <path
        fill={fillColor}
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M17.5 6.65a3.75 3.75 0 1 0 7.5 0 3.75 3.75 0 0 0-7.5 0Z"
      />
      <path
        fill={fillColor}
        d="m22.5 5.4-1.312 2.32a.389.389 0 0 1-.109.125.264.264 0 0 1-.28.027.345.345 0 0 1-.122-.103L20 6.87"
      />
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m22.5 5.4-1.312 2.32a.389.389 0 0 1-.109.125.264.264 0 0 1-.28.027.345.345 0 0 1-.122-.103L20 6.87"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill={fillColor} d="M0 .4h30v30H0z" />
      </clipPath>
    </defs>
  </svg>
);

AssignedFile.propTypes = {
  color: PropTypes.string,
  fillColor: PropTypes.string
};

export default AssignedFile;
